import { render, staticRenderFns } from "./ShipInfo.vue?vue&type=template&id=93ecb58a&scoped=true&"
import script from "./ShipInfo.vue?vue&type=script&lang=js&"
export * from "./ShipInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShipInfo.vue?vue&type=style&index=0&id=93ecb58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ecb58a",
  null
  
)

export default component.exports